export default {
    name: 'Refund',

    props: {
        operation: {
            type: Object,
            required: true
        }
    }
};
